import Event from './event';

const eventEmitter = new Event();

export default eventEmitter;
